// Function loadMagnifyingGallery loads the MagnifyingGallery class by dynamically importing the js on demand if needed

export function loadMagnifyingGallery($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="MagnifyingGallery"]');

	if(!$wg) {
		// console.info('MagnifyingGallery: no widget found');
		return Promise.reject('MagnifyingGallery widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-magnifying-gallery-chunk" */ '../widgets/magnifyingGallery').then(wg => {

		const { MagnifyingGallery } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="MagnifyingGallery"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new MagnifyingGallery($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new MagnifyingGallery($wg);
		}


	}).catch(error => error+'An error occurred while loading the MagnifyingGallery widget');

}
